import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProgressRing } from '../../atoms/Progress/Progress.js';
import { cn } from '../../lib/cn.js';
import { useTranslate } from '../../lib/i18n.js';
import { CARD_SURFACE } from '../../lib/surface-styles.js';
/**
 * Score indicator (handoff, Molecules and Organisms > Results summary).
 *
 * The percentage is derived here rather than passed in, so the ring and the
 * "8 / 10 correct" line cannot disagree. V1 shows the score and nothing else:
 * no per-question breakdown, no trend.
 */
export function ScoreIndicator({ correctCount, questionCount, detail, className, }) {
    const t = useTranslate();
    const percent = questionCount > 0 ? Math.round((correctCount / questionCount) * 100) : 0;
    // The ring's accessible name and the figures beside it are worded
    // differently on purpose: "3 of 5 correct" reads aloud, "3 / 5 correct"
    // scans. Two keys, so a translation can make the same distinction.
    const label = t('ui.score.ringLabel', [correctCount, questionCount]);
    return (_jsxs("div", { className: cn(CARD_SURFACE, 'flex items-center gap-7 p-[30px]', className), children: [_jsx(ProgressRing, { value: percent, label: label }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("p", { className: "text-h3 font-semibold tabular-nums text-text", children: t('ui.score.value', [correctCount, questionCount]) }), detail ? _jsx("p", { className: "text-body-sm tabular-nums text-text-secondary", children: detail }) : null] })] }));
}
//# sourceMappingURL=ScoreIndicator.js.map